<template>
  <div>
    <div class="djt01">
      <div class="djt02" style="width: 130px;margin-right: 20px" @click="fpsbs" v-if="user.companyId == 1">
        <p class="djt04">划设备</p>
      </div>
      <div class="djt02" @click="addSB">
        <img src="@/assets/images/add01.png" class="djt03" alt="">
        <p class="djt04">添加设备</p>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt26">设备名称</div>
        <div class="djt26">设备编号</div>
        <div class="djt26">设备状态</div>
<!--        <div class="djt26">运营人员</div>-->
        <div class="djt26">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27" :title="item.name">{{item.name}}</div>
            <div class="djt27" :title="item.code">{{item.code}}</div>
            <div class="djt27" :title="item.name" v-if="item.state == 1">正常</div>
            <div class="djt27" :title="item.name" v-if="item.state == 2">异常</div>
            <div class="djt27" :title="item.name" v-if="item.state == null"></div>
<!--            <div class="djt27" :title="item.name">{{item.usernames}}</div>-->
            <div class="djt28">
<!--              <img title="查看日志" src="@/assets/images/ycs01.png" class="djy16" alt="" @click="toRz(item)">-->
              <div class="djt28-1">
                <img title="历史记录" src="@/assets/imgs/10.png" class="djy16" alt="" @click="toLs(item)">
                <span>记录</span>
              </div>
              <div class="djt28-1">
                <img title="设备配置" src="@/assets/imgs/11.png" class="djy16" alt="" @click="toPz(item)">
                <span>配置</span>
              </div>
              <div class="djt28-1">
                <img title="编辑广告" src="@/assets/imgs/12.png" class="djy16" alt="" @click="toGG(item)">
                <span>广告</span>
              </div>
              <div class="djt28-1">
                <img title="编辑运营人员" src="@/assets/imgs/13.png" class="djy16" alt="" @click="sbyw(item,index)">
                <span>运营</span>
              </div>
              <div class="djt28-1">
                <img title="编辑货道" src="@/assets/imgs/14.png" class="djy16" alt="" @click="toHd(item,index)">
                <span>货道</span>
              </div>
              <div class="djt28-1">
                <img title="编辑付款方式" src="@/assets/imgs/15.png" class="djy16" alt="" @click="toFk(item,index)">
                <span>付款</span>
              </div>
              <div class="djt28-1" v-if="item.islock == 2">
                <img title="解锁" src="@/assets/imgs/16.png" class="djy16" @click="suos(item)" alt="">
                <span>启用</span>
              </div>
              <div class="djt28-1" v-else>
                <img title="锁定" src="@/assets/imgs/17.png" class="djy16" @click="suos(item)" alt="" >
                <span>禁用</span>
              </div>
              <div class="djt28-1">
                <img title="编辑信息" src="@/assets/imgs/18.png" class="djy16" @click="toEd(item)" alt="">
                <span>修改</span>
              </div>
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>

    <xc-model :loading="isModel" title="添加设备" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div style="margin-top: 60px">
            <div style="display: flex;display: flex;justify-content: center;">
              <div class="djt19">设备名称：</div>
              <input type="text" v-model="sbName" placeholder="请输入设备名称" class="djt20">
            </div>
            <div style="display: flex;display: flex;justify-content: center;margin-top: 20px">
              <div class="djt19">设备编号：</div>
              <input type="text" v-model="sbNo" placeholder="请输入设备编号" class="djt20">
            </div>
          </div>
          <div class="djt21">
            <div class="djt22" @click="addSbs">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <xc-model :loading="xgModel" title="修改设备" :is_buttom="false" @cancel="xg_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div style="margin-top: 60px">
            <div style="display: flex;display: flex;justify-content: center;">
              <div class="djt19">设备名称：</div>
              <input type="text" v-model="xg_sbName" placeholder="请输入设备名称" class="djt20">
            </div>
            <div style="display: flex;display: flex;justify-content: center;margin-top: 20px">
              <div class="djt19">设备编号：</div>
              <input type="text" v-model="xg_sbNo" placeholder="请输入设备编号" class="djt20">
            </div>
          </div>
          <div class="djt21">
            <div class="djt22" @click="eds">修改</div>
            <div class="djt22" style="margin-left: 50px" @click="xg_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <xc-model :loading="zfModel" title="支付设置" :is_buttom="false" @cancel="zf_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div style="margin-top: 60px;display: flex;justify-content: center">
            <div class="djt35">
              <div class="djt38">
                <div class="djt36">
                  <img src="@/assets/images/wx01.png" class="djt37" alt="">
                  <p class="sjt39">微信支付</p>
                </div>
                <div class="djt39">
                  <el-switch
                    style="margin-top: 15px"
                    :width="40"
                    v-model="zfArr[1].is_check"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 15px;display: flex;justify-content: center">
            <div class="djt35">
              <div class="djt38">
                <div class="djt36">
                  <img src="@/assets/images/zfb01.png" class="djt37" alt="">
                  <p class="sjt39">支付宝支付</p>
                </div>
                <div class="djt39">
                  <el-switch
                    style="margin-top: 15px"
                    :width="40"
                    v-model="zfArr[0].is_check"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 15px;display: flex;justify-content: center">
            <div class="djt35">
              <div class="djt38">
                <div class="djt36">
                  <img src="@/assets/images/zfs01.png" class="djt37" alt="">
                  <p class="sjt39">刷卡</p>
                </div>
                <div class="djt39">
                  <el-switch
                    style="margin-top: 15px"
                    :width="40"
                    v-model="zfArr[2].is_check"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
          <div class="djt21">
            <div class="djt22" @click="edFk">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="zf_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <xc-model :loading="pzModel" title="参数配置" :is_buttom="false" @cancel="pz_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div style="margin-top: 60px">
            <div style="display: flex;display: flex;justify-content: center;">
              <div class="djt19" style="width: 110px">设备参数：</div>
              <textarea v-model="pzInp" class="djl1" placeholder="请输入刀具柜配置（JSON格式）"></textarea>
            </div>
          </div>
          <div class="djt21">
            <el-button style="line-height: 0" class="djt22" @click="addPz" :loading="pzLoad">确定</el-button>
            <div class="djt22" style="margin-left: 50px" @click="pz_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <xc-model :loading="fpModel" title="分配设备" :is_buttom="false" @cancel="fp_cancel">
      <div slot="mbody">
        <div class="djt17">
          <div style="margin-top: 60px">
            <div style="display: flex;display: flex;justify-content: center;">
              <div class="djt19" style="width: 110px">设备编号：</div>
              <input type="text" v-model="sbbh" placeholder="请输入设备编号" class="djt20">
            </div>
          </div>
          <div style="margin-top: 25px;position:relative;">
            <div style="display: flex;display: flex;justify-content: center;">
              <div class="djt19" style="width: 110px">选择公司：</div>
              <input type="text" @input="seaerCom" v-model="seaCom" placeholder="输入公司名称进行搜索" class="djt20">
            </div>
            <div class="djt40">
              <div class="djt41"></div>
              <div class="djt42">
                <div class="djt43" v-for="(item,index) in comlist" :key="'com'+index" @click="addCom(item)">
                  {{item.name}}
                </div>
                <div class="djt44" v-if="comlist.length > 0" @click="closeSer">关闭搜索</div>
              </div>
            </div>
          </div>
          <div class="djt21">
            <el-button style="line-height: 0" class="djt22" @click="addComs" :loading="pzLoad">确定</el-button>
            <div class="djt22" style="margin-left: 50px" @click="fp_cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <style>
      .el-button:focus, .el-button:hover {
        color: white;
        border-color: #409EFF;
        background-color: #409EFF;
      }
    </style>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djglist",
    data(){
      return{
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        sbName:'',
        sbNo:'',
        xg_sbName:'',
        xg_sbNo:'',
        zfModel:false,
        lsItem:[],
        zfArr:[
          {is_check:false},
          {is_check:false},
          {is_check:false},
        ],
        xgModel:false,
        hdModel:false,
        hengl:'',
        shul:'',
        pzModel:false,
        pzInp:'',
        pzLoad:false,
        user:[],
        fpModel:false,
        sbbh:'',
        seaCom:'',
        comlist:[],
        comItem:[],
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      me.user = user;
    },
    mounted() {
      let data = {
        companyid:user.companyId,
        pageSize:me.pageSize,
        page:1,
      }
      httpUser.djglist(data).then(res => {
        console.log(res);
        me.data = res.data;
        me.loading = false;
      })
    },
    methods:{
      closeSer(){/*关闭搜索*/
        me.seaCom = '';
        me.comlist = [];
      },
      addComs(){/*点击确定分配*/
        if (me.sbbh == '') {
          me.$message.error('请输入设备编号');
          return false;
        }
        if (me.comItem.length == 0) {
          me.$message.error('请选择公司');
          return false;
        }
        me.pzLoad = true;
        let data = {
          companyid:me.comItem.id,
          code:me.sbbh,
        }
        httpUser.delimitdevice(data).then(res => {
          me.pzLoad = false;
          switch (res.code) {
            case "0000":
              me.$message.success('已分配设备');
              me.fp_cancel();
              break;
            case "1001":
              me.$message.error('设备编号不存在');
              break;
          }
        })
      },
      addCom(item){/*点击选择公司*/
        me.seaCom = item.name;
        me.comItem = item;
        me.comlist = [];
      },
      seaerCom(e){/*输入关键词搜索公司*/
        console.log(e,'company');
        console.log(me.seaCom,'gjc');
        if (me.seaCom == '') {
          me.comlist = [];
          return false;
        }
        let data = {
          companyId:'',
          state: 1,
          companyName:me.seaCom,
          sign:user.sign,
          mobile:user.mobile,
          page:1,
          pageSize:10000
        }
        httpUser.getComList(data).then(res => {
          console.log(res,'ress');
          me.comlist = res.data.dataList;
        })
      },
      fpsbs(){/*前往分配设备*/
        me.fpModel = true;
      },
      fp_cancel(){/*分配设备返回*/
        me.fpModel = false;
        setTimeout(function () {
          me.sbbh = '';
          me.comItem = [];
          me.comlist = [];
          me.seaCom = '';
        },500);
      },
      toLs(item){/*前往查看历史记录*/
        // console.log(item,"??")
        me.$router.push({path:'/djgls',query:{id:item.id}});
      },
      addPz(){/*确定修改添加配置*/
        if (me.pzInp == '') {
          me.$message.error('请输入配置信息');
          return false;
        }
        me.pzLoad = true;
        let data = {
          id:me.lsItem.id,
          configdetail:me.pzInp,
        }
        httpUser.adddjg(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:user.companyId,
                pageSize:me.pageSize,
                page:1,
              }
              httpUser.djglist(data).then(res => {
                console.log(res);
                me.data = res.data;
                me.pzLoad = false;
                me.pzModel = false;
                me.$message.success('成功编辑配置项');
              })
              break;
            case "1111":
              me.pzLoad = false;
              me.$message.error('系统错误，请联系管理员');
              break;
          }
        })
      },
      pz_cancel(){/*刀具柜配置弹窗返回*/
        me.pzModel = false;
      },
      toPz(item){/*打开刀具柜配置*/
        me.pzInp = item.configdetail;
        me.lsItem = item;
        me.pzModel = true;
      },
      toRz(item){//查看刀具柜日志
        me.$router.push({path:'/djgrz',query:{id:item.id}});
      },
      toGG(item){
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑广告');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({path:'/djggg',query:{id:item.id}});
      },
      toHd(item){//前往添加货道
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({path:'/djghd',query:{id:item.id}});
      },
      addhd(){//编辑货道

      },
      toEd(item){//前往修改
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','设备修改');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.lsItem = item;
        me.xg_sbName = item.name;
        me.xg_sbNo = item.code;
        me.xgModel = true;
        console.log(item);
      },
      eds(){//确定修改
        console.log(11122);
        if (me.xg_sbName == '' || me.xg_sbName == null || me.xg_sbName.indexOf(' ') != -1) {
          me.$message.error('请正确输入设备名称');
          return false;
        }
        if (me.xg_sbNo == '' || me.xg_sbName == null || me.xg_sbNo.indexOf(' ') != -1) {
          me.$message.error('请正确输入设备编号');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:me.lsItem.id,
          name:me.xg_sbName,
          code:me.xg_sbNo,
        }
        httpUser.adddjg(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:user.companyId,
                pageSize:me.pageSize,
                page:me.page,
              }
              httpUser.djglist(data).then(res => {
                me.xgModel = false;
                me.data = res.data;
                me.$Loading.finish();
                me.$message.success('已修改');
              })
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('设备编号不存在');
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      suos(item){//锁定或者解锁设备
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','刀具柜锁定');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:item.id,
          lockuserid:user.userId,
          islock:'',
        }
        if (item.islock == 1) {
          data['islock'] = 2;
        } else {
          data['islock'] = 1;
        }
        // console.log(data);return false;
        httpUser.deviceislock(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:user.companyId,
                pageSize:me.pageSize,
                page:me.page,
              }
              httpUser.djglist(data).then(res => {
                console.log(res);
                me.data = res.data;
                me.$Loading.finish();
                me.$message.success('已修改');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      edFk(){//点击确定修改付款方式
        me.$Loading.finish();
        let data = {
          list:[],
          deviceid:me.lsItem.id,
        }
        me.zfArr.forEach(function (item,index) {
          if (item.is_check == true) {
            let arr = {
              paytypeid:item.id,
              deviceid:me.lsItem.id,
              cuserid:user.userId,
            }
            data['list'].push(arr);
          }
        })
        // console.log(data);return false;
        httpUser.setdevicepaytype(data).then(res => {
          switch (res.code) {
            case "0000":
              me.$Loading.finish();
              me.zfModel = false;
              me.$message.success('修改成功');
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      toFk(item,index){//修改付款方式
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','设置付款方式');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        me.lsItem = item;
        let data = {
          deviceid:item.id,
        }
        httpUser.getpaytypelist(data).then(res => {
          me.zfArr = res.data.datalist;
          if (res.data.datalist[0].devicepaystate == 1) {
            me.$set(me.zfArr[0],'is_check',true);
          } else {
            me.$set(me.zfArr[0],'is_check',false);
          }
          if (res.data.datalist[1].devicepaystate == 1) {
            me.$set(me.zfArr[1],'is_check',true);
          } else {
            me.$set(me.zfArr[1],'is_check',false);
          }
          if (res.data.datalist[2].devicepaystate == 1) {
            me.$set(me.zfArr[2],'is_check',true);
          } else {
            me.$set(me.zfArr[2],'is_check',false);
          }
          console.log(me.zfArr);
          me.zfModel = true;
          me.$Loading.finish();
        })
      },
      sbyw(item,index){//设备运维
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','运营人员管理');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        } else {
          me.$router.push({path:'/djgyy',query:{id:item.id}});
        }
      },
      addSbs(){//确定添加设备
        if (me.sbName == '' || me.sbName == null || me.sbName.indexOf(' ') != -1) {
          me.$message.error('请正确输入设备名称');
          return false;
        }
        if (me.sbNo == '' || me.sbNo == null  || me.sbNo.indexOf(' ') != -1) {
          me.$message.error('请正确输入设备编号');
          return false;
        }
        me.$Loading.start();
        let data = {
          name:me.sbName,
          tuserid:user.userId,
          companyid:user.companyId,
          code:me.sbNo
        }
        httpUser.adddjg(data).then(res => {
          switch (res.code) {
            case "0000":
              me.isModel = false;
              let data = {
                companyid:user.companyId,
                pageSize:me.pageSize,
                page:1,
              }
              httpUser.djglist(data).then(res => {
                me.$Loading.finish();
                me.data = res.data;
                me.$message.success('已添加设备');
              })
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('设备编号不存在');
              break;
            case "1002":
              me.$Loading.error();
              me.$message.error('设备编码已被添加过');
              break;
          }
        })
      },
      addSB(){
        me.sbName = '';
        me.sbNo = '';
        me.isModel = true;
      },
      cancel(){
        me.isModel = false;
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          companyid:user.companyId,
          pageSize:me.pageSize,
          page:parseInt(e),
        }
        me.page = e;
        httpUser.djglist(data).then(res => {
          me.data = res.data;
          me.loading = false;
        })
      },
      zf_cancel(){
        me.zfModel = false;
      },
      xg_cancel(){
        me.xgModel = false;
      },
      hd_cancel(){
        me.hdModel = false;
      }
    }
  }
</script>

<style scoped>
@import "djglist.css";
</style>